// removed by extract-text-webpack-plugin
module.exports = {"documents":"_1EnlsW4zy8i85JYjM2R4Bg","readmore":"_1qn5g2o1_aSAb1QS_pnT8m"};


//////////////////
// WEBPACK FOOTER
// ./src/components/DocumentListBlock/DocumentListBlock.module.scss
// module id = 752
// module chunks = 0